<template>
    <div class="table">
        <div class="container">
            <el-form :model="formData" :rules="rules" :label-position="labelPosition" label-width="140px">
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="库存节点名称" prop="nodeName">
                            <el-input class="de-input" v-model="formData.nodeName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="库存节点编号" prop="nodeNo">
                            <el-input class="de-input" v-model="formData.nodeNo" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="库存节点组" prop="nodeGroup">
                            <el-select v-model="formData.nodeGroup" class="handle-input">
                                <el-option key="1" label="外库" value="外库"></el-option>
                                <el-option key="2" label="成品库" value="成品库"></el-option>
                                <el-option key="3" label="工厂库" value="工厂库"></el-option>
                                <el-option key="4" label="供应商" value="供应商"></el-option>
                                <el-option key="6" label="客户" value="客户"></el-option>
                                <el-option key="7" label="制造" value="制造"></el-option>
                                <el-option key="8" label="维修" value="维修"></el-option>
                                <el-option key="9" label="售后" value="售后"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否有效" prop="isEffective">
                            <el-select v-model="formData.isEffective" class="handle-input">
                                <el-option key="1" label="是" value="是"></el-option>
                                <el-option key="0" label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="运输地址">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主要联系人">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="主要联系人电话">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主要联系人邮箱">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="次要联系人">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="次要联系人电话">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="次要联系人邮箱">
                            <el-input class="de-input" v-model="formData.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row class="btn-row">
                <el-button type="primary" @click="saveNodeInfo">保存</el-button>
                <el-button type="primary" @click="cancel">取消</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
    import router from '../../../../router'
    export default {
        name: 'inventory-node-edit',
        data() {
            return {
                formData: [{
                    nodeName: 'VB-1967434343',
                    nodeNo: '',
                    nodeGroup: '123456',
                    isEffective: '00000000',
                    name: ''
                }],
                rules: {
                    nodeName: [{required: true, message: '请输入料架类型编号', trigger: 'blur' }],
                    nodeNo: [{required: true, message: '请输入料架类型名称', trigger: 'blur' }],
                    nodeGroup: [{required: true, message: '请输入BCM号', trigger: 'blur' }],
                    isEffective: [{required: true, message: '请输入BCM号', trigger: 'blur' }]
                },
                labelPosition: 'right',
                fileList:[]
            }
        },
        created(){
            let nodeName = this.$route.params.nodeName;
            if(nodeName){
              this.getMaterialDetail(nodeName);
            }
        },
        methods: {
            /**
             * 保存inventoryNode
             */
            saveNodeInfo(){

            },
            /**
             * 取消编辑
             */
            cancel(){
                router.replace({
                    path: './route-node'
                });
            },
            /**
             * 获取inventoryNode详情信息
             * @param no
             */
            getMaterialDetail(nodeName){

            }
        }
    }
</script>
<style scoped>
    .btn-row{
        margin-bottom: 20px;
        margin-top: 10px;
        text-align: center;
    }
    .de-input{
        width:60%;
    }
    .handle-input{
        width: 60%;
    }
    .el-form-item__label{
        width:125px;
    }
    .el-upload--text{
        border: none;
        width: auto;
        height: auto;
    }
</style>